




























































































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { StudentSubjectRow, StudentSheet } from "../modules/student/SheetList"
import * as Common from "../commons/common"
import moment from 'moment';


export default defineComponent({
  props: {
    row_idx: {
      type: Number as PropType<number>,
      requier: true,
    },
    col_idx: {
      type: Number as PropType<number>,
      requier: true,
    },
    reportNos: {
      type: Array as PropType<number[]>,
      requier: true,
    },
    sheetTypes: {
      type: Array as PropType<number[]>,
      requier: true,
    },
    sheetType: {
      type: Number as PropType<number>,
      required: false,
      default: null,
    },
    row: {
      type: Object as PropType<StudentSubjectRow>,
      requier: true,
    },
    studentSheet: {
      type: Object as PropType<StudentSheet>,
      requier: true,
    },
  },
  setup (props, context) {

    const SheetTypeEnum = Common.SheetTypeEnum;
    const StudentSheetStatusEnum = Common.StudentSheetStatusEnum;
    // 新設列は固定種別、既存のレポート列は従来の配列から表示種別を判定する
    const targetSheetType = computed(() => props.sheetType == null ? props.sheetTypes[props.col_idx] : props.sheetType);

    /******************************
    * 日時を画面表示文言にコンバート
    ******************************/

    const convertDateString = (date: string) => {
      return date ? moment(date).format('MM月DD日HH時mm分') : "-";
    };

    const goResultImagePreview = (student_sheet_id: number) => {
      context.emit("go-result-image-preview", student_sheet_id);
    }

    const goCorrectImagePreview = (base_sheet_id: number) => {
      context.emit("go-correct-image-preview", base_sheet_id);
    }

    const answerStart = (subject_code: string, nendo: number, report_no: number, studentSheet: StudentSheet, is_preview_mode: boolean) => {
      const param = {
        subject_code: subject_code,
        nendo: nendo,
        report_no: report_no,
        studentSheet: studentSheet,
        is_preview_mode: is_preview_mode,
      }
      context.emit("answer-start", param);
    }

    const answerStartByMizuho = (subject_code: string, nendo: number, report_no: number, studentSheet: StudentSheet, is_preview_mode: boolean) => {
      const param = {
        subject_code: subject_code,
        nendo: nendo,
        report_no: report_no,
        studentSheet: studentSheet,
        is_preview_mode: is_preview_mode,
      }
      context.emit("answer-start-by-mizuho", param);
    }

    return {
      SheetTypeEnum,
      StudentSheetStatusEnum,
      targetSheetType,
      convertDateString,
      goResultImagePreview,
      goCorrectImagePreview,
      answerStart,
      answerStartByMizuho,
    }
  }
});
